import { checkMenuPermission, checkOperationPermission } from '@/utils/permission'

export default {
  methods: {
    checkMenuPermission,
    checkOperationPermission
  }
}



// WEBPACK FOOTER //
// ./src/mixin/permission.js